<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Edit Portfolio" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="edit()" ngNativeValidate>
          <app-portfolio-form [portfolio]="portfolio" *ngIf="portfolio"></app-portfolio-form>
        </form>
      </div>
    </section>
  </div>
</div>
